<list-view [liste]="listeActionsWf" *ngIf="listeActionsWf"></list-view>
<repartition-analytique *ngIf="portee !== TypePortee.AV"
        [listeVentilations]="listeVentilations"
        [typeEntite]="typeEntite"
        [isObjetValide]="isObjetValide"
        [portee]="portee"
        [idObjet]="idObjet"
        [globalSettings]="globalSettings">
</repartition-analytique>
